import { EEventType } from '../../types/events';
import { EActiveView } from '../../types/view';
import { ERestoreStatus } from '../../types/authentication';
import { ESentEmailType } from '../../types/sentEmail';
import { AUTHENTICATION_RESTORE_TYPE } from '../../constants/action_types';
import { remind } from '../../api/remind';
import { changeView } from '../view';
import { trackForgotPasswordSubmitSuccess } from '../../utils/tracking';
export function restore(_ref) {
  var email = _ref.email,
    source = _ref.source,
    nextView = _ref.nextView;
  return function (dispatch, _getState, context) {
    dispatch({
      status: ERestoreStatus.Loading,
      type: AUTHENTICATION_RESTORE_TYPE
    });
    return remind(context.httpApi, {
      email: email
    }).then(function (response) {
      if (response.statusCode === 204) {
        dispatch({
          status: ERestoreStatus.Succeed,
          type: AUTHENTICATION_RESTORE_TYPE
        });
        trackForgotPasswordSubmitSuccess(source);
        dispatch(changeView(EActiveView.EmailSent, {
          type: ESentEmailType.Restore,
          email: email,
          nextView: nextView
        }));
        context.emitter.emit(EEventType.RestoreSucceed, {
          email: email
        });
        return;
      }
      dispatch({
        status: ERestoreStatus.Failed,
        type: AUTHENTICATION_RESTORE_TYPE,
        error: response.response.message
      });
    }).catch(function (error) {
      context.logger.error(error, {
        domain: 'auth-widget.api.restore'
      });
      dispatch({
        status: ERestoreStatus.Failed,
        type: AUTHENTICATION_RESTORE_TYPE,
        error: 'Произошла непредвиденная ошибка'
      });
    });
  };
}